
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachDiagnosticsRootListFormRemove} from "@/models/app/coach/diagnostics/root/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "diagnostic",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachDiagnosticsRootListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  formData: AppCoachDiagnosticsRootListFormRemove = new AppCoachDiagnosticsRootListFormRemove();

  diagnostic: AppCoachDiagnosticsRootListFormRemove = new AppCoachDiagnosticsRootListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/diagnostic/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getDiagnostics');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.diagnostic;
  }

  resetFormData(): void {
    this.formData = new AppCoachDiagnosticsRootListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
